import { useEffect, useState } from "react";
import {
  DataSource,
  PusherResponse,
} from "../../_config/interfaces/interfaces";
import { usePusherDataSelector } from "../../store/selectors/pusherSelector";

interface IncomingProps {
  dataSource: DataSource;
}
interface DisplayData extends PusherResponse {
  statusText: string;
}

const DataSourceStatus = ({ dataSource }: IncomingProps) => {
  const [displayData, setDisplayData] = useState<DisplayData>();
  const pusherData = usePusherDataSelector();

  const getTextColor = (status: string | undefined) => {
    switch (status) {
      case 'completed':
        return 'text-green-500';

      case 'processing':
      case 'pending':
        return 'text-yellow-700';

      case 'fetching':
        return 'text-blue-500';

      case 'failed':
        return 'text-red-500';
      default:
        return '';
    }
  }

  useEffect(() => {
    if (pusherData.length) {
      pusherData.forEach((item: PusherResponse) => {
        if (item.datasource_id == dataSource.ds_id) {
          const statusText =
            item.processed < item.total
              ? `Analyzing ${item.processed}/${item.total} records`
              : "completed";
          setDisplayData({ ...item, statusText });
        } else {
          setDisplayData({
            datasource_id: dataSource.ds_id,
            percent: 100,
            processed: 0,
            total: 0,
            status_msg: dataSource.last_fetch_status ?? 'failed',
            status: dataSource.last_fetch_status ?? 'failed',
            statusText: dataSource.last_fetch_status ?? 'failed',
          });
        }
      });
    }else {
      setDisplayData({
        datasource_id: dataSource.ds_id,
        percent: 100,
        processed: 0,
        total: 0,
        status_msg: dataSource.last_fetch_status ?? 'failed',
        status: dataSource.last_fetch_status ?? 'failed',
        statusText: dataSource.last_fetch_status ?? 'failed',
      });
    }
  }, [dataSource, pusherData]);
  console.log("displayData", { displayData, dataSource, pusherData });

  return (
    <div className="flex justify-start flex-col">
      <div className={getTextColor(displayData?.status)}>
        {displayData?.status_msg}
        {/* {['analyze','analyzing'].includes(dataSource.last_fetch_status) ? 'Analyzing 10/30 records' : dataSource.last_fetch_status} */}
      </div>
      {displayData?.status == "processing" ?
        <div className="w-full bg-gray-300 rounded-full h-3 mb-2 overflow-hidden">
            <div
            className={
                "h-3 bg-yellow-500 animate-stripes striped-bg rounded-l-full"
            }
            role="progressbar"
            aria-label="Progress"
            aria-valuenow={displayData?.percent}
            aria-valuemin={0}
            aria-valuemax={100}
            style={{ width: `${displayData?.percent}%` }}
            />
        </div>
      : null }
    </div>
    // <div>
    //   <h3>Data source: {dataSource.ds_id}</h3>
    //   <p>
    //     Processed: {processed} / {total} ({pct}%)
    //   </p>
    //   <progress value={processed} max={total} />
    // </div>
  );
};

export default DataSourceStatus;
